module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.user) ? [(_vm.user.roles[0] === 'admincliente' || _vm.user.roles[0] === 'user') ? _c('carrito-lateral', {
    attrs: {
      "carrito": _vm.carrito,
      "mostrar": _vm.mostrarCarrito,
      "user": _vm.user
    },
    on: {
      "toggle-carrito": _vm.onToggleCarrito,
      "disminuir-cantidad": _vm.onDisminuirCantidadPlatoDia,
      "agregar-carrito": _vm.onAgregarCarrito,
      "mostrar-notificacion": _vm.onMostrarNotificacion
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('keep-alive', [_c('topbar', {
    attrs: {
      "user": _vm.user,
      "carrito": _vm.carrito
    },
    on: {
      "toggle-carrito": _vm.onToggleCarrito,
      "try-logout": _vm.onTryLogout
    }
  })], 1), _vm._v(" "), _c('router-view', {
    attrs: {
      "carrito": _vm.carrito,
      "user": _vm.user,
      "maps-loaded": _vm.mapsLoaded
    },
    on: {
      "try-login": _vm.onTryLogin,
      "toggle-carrito": _vm.onToggleCarrito,
      "esconder-carrito": _vm.onCerrarCarrito,
      "activar-modal": _vm.onActivarModal,
      "cerrar-modal": _vm.onCerrarModal,
      "agregar-carrito": _vm.onAgregarCarrito,
      "asignar-plato": _vm.onAsignarPlatoEmpleado,
      "desasignar-plato": _vm.onDesasignarPlatoProveedor,
      "disminuir-cantidad": _vm.onDisminuirCantidadPlatoDia,
      "mostrar-notificacion": _vm.onMostrarNotificacion,
      "vaciar-carrito": _vm.onVaciarCarrito,
      "try-logout": _vm.onTryLogout,
      "user-loggged": _vm.onUserLogged,
      "perfil-changed": _vm.onPerfilChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('footer', {
    staticClass: "footer white",
    staticStyle: {
      "border-top-width": "0px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "footer-links"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/faq"
    }
  }, [_c('a', [_vm._v("Preguntas frecuentes")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/partners"
    }
  }, [_c('a', [_vm._v("Partners")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/terminos"
    }
  }, [_c('a', [_vm._v("Términos y Condiciones")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/privacidad"
    }
  }, [_c('a', [_vm._v("Privacidad")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/contacto"
    }
  }, [_c('a', [_vm._v("Contacto")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2017 andalepide.com - Todos los derechos reservados")])])])])]), _vm._v(" "), _c('div', {
    ref: "modalEspere",
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('img', {
    ref: "pajarito",
    staticClass: "animation-target",
    attrs: {
      "src": "/images/bird.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Procesando su petición")]), _vm._v(" "), _c('span', [_vm._v("Por favor no cierre el navegador")])])])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "social"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/andalepide",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.twitter.com/andalepide",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/andalepide",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c95520"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1131
// module chunks = 5